import { NgModule, ModuleWithProviders } from '@angular/core';
import {MomentModule} from 'ngx-moment';
import {MaterialimportsModule} from './material-imports.module';
import {RSDialogModule} from '../libs/rsnotify/rsdialog.module';
import {RSValidatorModule} from '../libs/rsvalidator/rsvalidator.module';
import {RSloadingModule} from '../libs/rsloading/rsloading.module';
import {RSDebuggerModule} from '../libs/rsdebugger/rsdebugger.module';

import {
  IRSLoadingModalDefaults,
  RSLoadingModalDefaults, RSLoadingModalIconAnimation, RSLoadingModalSpinkitType,
  RSLoadingModalSpinner
} from '../libs/rsloading/rsloading.modal.defaults';
import {RSDialog} from '../libs/rsnotify/rsdialog';
import {MatIconRegistry} from '@angular/material/icon';
import {RSValidator, RSValidatorService} from '../libs/rsvalidator/rsvalidator.service';
import {CommonModule, PercentPipe, TitleCasePipe} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MaterialElevationDirective} from './directives/elevation-hover';
import {FormsModule} from '@angular/forms';
import {ComponentCanDeactivateGuardService} from './services/componentCanDeactivate';
import {UserService} from './services/user.service';
import {DataService, ResolveAssistanceType, ResolveCategory, ResolveLga, ResolvePracticeChangeActivity, ResolveRiskType, ResolveUser} from './services/data.service';
import {RSDialogService} from '../libs/rsnotify/rsdialog.service';
import {RSDebuggerService} from '../libs/rsdebugger/rsdebugger.service';
import {RSLoadingModalService} from '../libs/rsloading/rsloading.service';
import {FirebaseAuthResolver, FirebaseAwaitResolver} from './services/firebase-auth-resolver';
import { WebStorageModule } from '@efaps/ngx-store';
import {CamelConvertPipe, OrderByPipe, PropertyIdFormatter, PropertySummaryName} from './services/utilities.service';
import {BackButtonDirective, NavigationService} from './services/navigation.service';
import {NgxMatDatetimePickerModule, NgxMatNativeDateModule} from '@angular-material-components/datetime-picker';
import {ColorCompactModule} from 'ngx-color/compact';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {HighchartsChartModule} from 'highcharts-angular';

import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import theme from 'highcharts/themes/grid-light';
HC_exporting(Highcharts);
theme(Highcharts);


export function loadingModalDefaults(): RSLoadingModalDefaults {
  const params: IRSLoadingModalDefaults = {
    type: RSLoadingModalSpinner.SpinKit,
    spinkit: RSLoadingModalSpinkitType.CubeGrid,
    color: ['primary', 'primary', 'accent', 'primary', 'accent', 'primary', 'accent'],
    size: 200,
    dialogConfig: {
      hasBackdrop: true,
      hasBackground: false,
      hasShadow: false,
    } as RSDialog.Options
  };
  return new RSLoadingModalDefaults(params);
}

@NgModule({
  declarations: [
    MaterialElevationDirective,
    BackButtonDirective,

    // Pipes
    PropertySummaryName,
    CamelConvertPipe,
    PropertyIdFormatter,
    OrderByPipe,
    ResolveCategory,
    ResolveUser,
    ResolveLga,
    ResolveAssistanceType,
    ResolveRiskType,
    ResolvePracticeChangeActivity,

  ],
  imports: [
    CommonModule,

    MomentModule,
    MaterialimportsModule,
    FormsModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,

    // RSTools
    RSDialogModule,
    RSValidatorModule.forRoot(),
    RSloadingModule.forRoot(loadingModalDefaults),
    RSDebuggerModule,

    WebStorageModule,
    FlexLayoutModule,

    ColorCompactModule,
    NgxMatSelectSearchModule,

    HighchartsChartModule
  ],
  providers: [
    PercentPipe,
    MaterialElevationDirective,
    BackButtonDirective,
    TitleCasePipe,

    FirebaseAuthResolver,
    FirebaseAwaitResolver,

    ComponentCanDeactivateGuardService,
    UserService,
    DataService,
    RSDialogService,
    RSDebuggerService,
    RSLoadingModalService,

    // Pipes
    PropertySummaryName,
    CamelConvertPipe,
    PropertyIdFormatter,
    OrderByPipe,
    ResolveCategory,
    ResolveLga,
    ResolveAssistanceType,
    ResolvePracticeChangeActivity,
    ResolveRiskType,
    ResolveUser
  ],
  exports: [
    CommonModule,

    PercentPipe,
    TitleCasePipe,

    MomentModule,
    MaterialimportsModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,

    RSDialogModule,
    RSValidatorModule,
    RSloadingModule,
    RSDebuggerModule,

    FlexLayoutModule,

    MaterialElevationDirective,
    BackButtonDirective,
    PropertySummaryName,
    CamelConvertPipe,
    PropertyIdFormatter,
    OrderByPipe,
    ResolveCategory,
    ResolveUser,
    ResolveLga,
    ResolveAssistanceType,
    ResolvePracticeChangeActivity
  ],
})
export class SharedModule {
  constructor(
      private matIconRegistry: MatIconRegistry,
      private validator: RSValidatorService,
      private navigationService: NavigationService,
  ) {
    // Init (so it starts) the NavigationService
    this.navigationService.init();

    // Register fontawesome
    // matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    const jsonFields: any = {
      required: {
        type: 'r'
      },
      percentZero: {
        type: 'n',
        min: 0,
        max: 100.01,
        decimals: true
      },
      percentGreaterZero: {
        type: 'n',
        min: 0.01,
        max: 100.01,
        decimals: true
      },
      greaterZero: {
        type: 'n',
        min: 0.0001,
        decimals: true
      },
      greaterEqualZero: {
        type: 'n',
        min: 0,
        decimals: true
      },
      true: {
        type: 's',
        regex: 'true'
      },
      equalZero: {
        type: 'n',
        min: 0,
        max: 0
      },
      pc_likelihood: {
        type: 'n',
        min: 0.01,
        max: 1,
        decimals: true
      },
      email: {
        type: 's',
        regex: 'email',
        min: 2,
        max: 256,
        error: 'Please enter a valid email address.'
      },
      password: {
        type: 's',
        min: 6,
        max: 50,
        // regex: 'password',
        error: 'Please enter a password between 6 and 50 characters.' // containing both numbers and letters
      },
      cat_name: {
        type: 's',
        min: 3,
        max: 30,
        error: 'You must enter a name between 3 and 30 characters.'
      },
      cat_icon: {
        type: 's',
        min: 1,
        max: 60,
        error: 'You must enter a valid icon from the icon list.'
      },
      event_name: {
        type: 's',
        min: 3,
        max: 256,
        error: 'You must enter a name between 3 and 256 characters.'
      },
      event_town: {
        type: 's',
        min: 3,
        max: 256,
        error: 'You must enter a town of at least 3 characters.'
      },
      meeting_topic: {
        type:'s',
        min: 3,
        max: 256,
        error: 'You must enter a topic between 3 and 256 characters.'
      },
      contact_inputs: {
        type: 's',
        min: 1,
        max: 100,
        error: 'You must enter a value between 1 and 100 characters.'
      },
      greaterZeroInteger: {
        type: 'n',
        min: 1,
        decimals: false,
        error: 'You must enter a value greater than 0.'
      },
    };
    const jsonRegex: any = {
      email: {
        pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
        flags: 'i'
      },
      // password: {
      //   pattern: '^(?=.*[a-zA-Z])(?=.*[0-9])',
      //   flags: 'i'
      // },
      true: {
        pattern: '^true$',
        flags: 'i'
      },
      url: {
        pattern: '(https?:\\/\\/)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
        flags: 'i'
      },
      url_strict: {
        pattern: '(https?:\\/\\/)(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
        flags: 'i'
      },
      export_type: {
        pattern: '^(jpeg|png)$',
        flags: 'i'
      },
      android_id: {
        pattern: '^([A-Za-z]{1}[A-Za-z\\d_]*\\.)+[A-Za-z][A-Za-z\\d_]*$',
        flags: 'i'
      },
      apple_id: {
        pattern: '^\\d{0,12}$',
        flags: 'i'
      }
    };
    const rules: RSValidator.Rules = validator.parseRules(jsonFields, jsonRegex);
    validator.setRules(rules);
  }

  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [ ]
    };
  }
}
